import classes from "../styles/App.module.scss";
import { useRef, useState, useCallback, FC } from "react";
import { InputArea } from "./InputArea";
import { OutputArea } from "./OutputArea";
import { useMemoList } from "../hooks/useMemoList";

export const App: FC = () => {
  const inputElement = useRef<HTMLInputElement>(null);
  const {outputText, addTodo, deleteTodo} = useMemoList();
  const [onComposition, setOnComposition] = useState(false);

  /*
   * キーボードが入力中どうかの判定
   * 変換中にイベントが発火してしまう問題への対処
   * https://github.com/facebook/react/issues/3926#issuecomment-929799564
  */
  const handleComposition = (event: React.CompositionEventHandler<HTMLInputElement> | any) => {
    if (event.type === "compositionstart") {
      setOnComposition(true);
    }
    if (event.type === "compositionend") {
      setOnComposition(false);
    }
  }

  /*
   * 追加ボタン押下時
   */
  const onClickAddButton = () => {
    addTodo(inputElement.current?.value);

    // フォームに入力した値をリセットする
    inputElement.current!.value = "";
  }

  /*
   * エンターキー押下時
   */
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !onComposition) {
      addTodo(inputElement.current?.value);

      // フォームに入力した値をリセットする
      inputElement.current!.value = "";
    }
  }

  /*
   * 削除ボタン押下時
   * @param {number} index リストの何番目が押されたかを示す番号
   */
  const onClickDeleteButton = useCallback((index: number) => {
    deleteTodo(index);
  }, [deleteTodo]);

  return(
    <div className={classes.container}>
      <h1 className={classes.title}>簡単メモアプリ</h1>

      <InputArea inputElement={inputElement} handleKeyDown={handleKeyDown} onClickAddButton={onClickAddButton} handleComposition={handleComposition} />
      <OutputArea outputText={outputText} onClickDeleteButton={onClickDeleteButton} />

    </div>
  );
};